'use client';

import { useDecisions } from '../../hooks';
import { OptimizelyLegacy } from './Optimizely.legacy';

export function OptimizelyScript() {
    const isOneTrust = useDecisions('onetrust');

    if (isOneTrust) return null;

    return <OptimizelyLegacy />;
}
